import script from "./SmartAlarm.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmartAlarm.vue?vue&type=script&lang=ts&setup=true"

import "./SmartAlarm.vue?vue&type=style&index=0&id=2cb0081c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb0081c"]])

export default __exports__